const mainNavigation = {
  $siteHeader: null,
  $mainNavMenu: null,
  $mainNavToggle: null,

  toggleButtonDisplay() {
    // Only proceed if we have the toggle button
    if (!this.$mainNavToggle) return;

    // Get current state from attribute
    const isMenuOpen = this.$mainNavToggle.getAttribute('data-menu-toggled') === 'true';

    // Find the open and close button elements
    const $openButton = this.$mainNavToggle.querySelector('.open');
    const $closeButton = this.$mainNavToggle.querySelector('.close');

    if ($openButton && $closeButton) {
      // Show close button and hide open button when menu is open
      $openButton.classList.toggle('is-hidden', isMenuOpen);
      $closeButton.classList.toggle('is-hidden', !isMenuOpen);
    }
  },

  toggle() {
    // Toggle the menu active state
    const isMenuOpen = this.$mainNavMenu.classList.toggle('is-active');

    // Update the header height
    const headerHeight = this.$siteHeader.offsetHeight;
    this.$mainNavMenu.style.top = isMenuOpen ? `${headerHeight - 1}px` : '';

    // Update the toggle button's attribute
    if (this.$mainNavToggle) {
      this.$mainNavToggle.setAttribute('data-menu-toggled', isMenuOpen ? 'true' : 'false');
    }

    // Update the button display
    this.toggleButtonDisplay();

    // Toggle body clipped class
    document.documentElement.classList.toggle('is-clipped', isMenuOpen);
  },

  setActiveNavItem() {
    // Get the current URL path (slug)
    const currentPath = window.location.pathname;

    // Find all navbar items and links
    const navItems = document.querySelectorAll('.navbar-menu .navbar-item, .navbar-menu .navbar-link');

    // Track if any item was found to be active
    let hasActiveItem = false;

    // Loop through all nav items
    navItems.forEach(item => {
      // Get the href attribute
      const href = item.getAttribute('href');

      // Skip items without href
      if (!href) return;

      // Check if the href matches the current path
      // We compare with both exact match and for homepage (/ can be empty or /)
      const isMatch =
        href === currentPath ||
        (currentPath === '/' && href === '') ||
        (currentPath === '' && href === '/');

      // Add or remove is-active class based on the match
      if (isMatch) {
        item.classList.add('is-active');
        hasActiveItem = true;

        // If this item is inside a dropdown, mark the parent dropdown as active too
        const parentDropdown = item.closest('.navbar-item.has-dropdown');
        if (parentDropdown) {
          const parentLink = parentDropdown.querySelector('.navbar-link');
          if (parentLink) {
            parentLink.classList.add('is-active');
          }
        }
      } else {
        item.classList.remove('is-active');
      }
    });

    // Second pass to handle parent dropdowns with active children
    if (!hasActiveItem) {
      // Find all dropdown menus
      const dropdowns = document.querySelectorAll('.navbar-item.has-dropdown');

      dropdowns.forEach(dropdown => {
        // Check if any children are active
        const hasActiveChild = dropdown.querySelector('.navbar-dropdown .navbar-item.is-active');

        // If a child is active, mark the parent link as active
        if (hasActiveChild) {
          const parentLink = dropdown.querySelector('.navbar-link');
          if (parentLink) {
            parentLink.classList.add('is-active');
          }
        }
      });
    }
  },

  init(){
    // Get elements
    mainNavigation.$siteHeader = document.querySelector('.site-header');
    mainNavigation.$mainNavMenu = document.querySelector('.main-nav .navbar-menu');
    mainNavigation.$mainNavToggle = document.querySelector('[data-main-nav-toggle]');

    // Exit init if missing elements
    if (!this.$mainNavMenu || !this.$mainNavToggle) {
      console.warn('Main navigation elements not found');
      return;
    }

    // Make sure initial button state is correct
    this.toggleButtonDisplay();

    // Set active navigation item based on current URL
    this.setActiveNavItem();

    // Add global click event listener
    document.addEventListener('click', evt => {
      const $clickedNavToggle = evt.target.closest('[data-main-nav-toggle]');

      if ($clickedNavToggle) {
        evt.preventDefault();
        evt.stopPropagation();
        this.toggle();
      }
    });
  }
};

export default mainNavigation;
